import { FC } from 'react';

import { Button, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { endSudoSession } from 'components/Header/HeaderUserDrop/EndSessionButton/endSudoSession';

import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

const TrlKeys = {
    endSession: 'userBar.sudoOut',
};

export const EndSessionButton: FC<{ isAdminHeader?: boolean }> = ({ isAdminHeader = false }) => {
    const isSudo = useSelector((state) => state.user?.sessionType === SessionType.Sudo);

    const trl = useTrls();

    if (!isSudo) {
        return null;
    }

    return (
        <>
            {!isAdminHeader && <VSpacing default={20} />}
            <Button
                mode="secondary"
                style={isAdminHeader ? 'constant' : 'accent'}
                size="small"
                stretched={!isAdminHeader}
                onClick={endSudoSession}
                data-qa="end-session-button"
            >
                {trl(TrlKeys.endSession)}
            </Button>
        </>
    );
};
